/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ document: NonNullable<unknown>, caseNumber: NonNullable<unknown> }} Notifications_Document_Classified_BodyInputs */

const en_notifications_document_classified_body = /** @type {(inputs: Notifications_Document_Classified_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.document}" was classified on case ${i?.caseNumber}.`)
};

const pt_br2_notifications_document_classified_body = /** @type {(inputs: Notifications_Document_Classified_BodyInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`"${i?.document}" foi classificado no caso ${i?.caseNumber}.`)
};

/**
* | output |
* | --- |
* | "\"{document}\" was classified on case {caseNumber}." |
*
* @param {Notifications_Document_Classified_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_document_classified_body = /** @type {((inputs: Notifications_Document_Classified_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Document_Classified_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_document_classified_body(inputs)
	return pt_br2_notifications_document_classified_body(inputs)
});